import { useState } from 'react';
import { getGender } from '@common/Brands/helpers/lastGender';
import { getRootNavigation } from '../helpers/getRootNavigation';
import { setNestingLvl } from '../helpers/setNestingLvl';

const getNavigationTrackingName = ({ name, trackingName }) => trackingName || name;

export const useNavigationStateHandler = (navigation) => {
    const navigationCopy = { ...navigation };
    setNestingLvl(navigationCopy);
    const [nestedNavigation] = useState(navigationCopy);

    const navigationStateFromPath = (navigationPath, genderSelection) => {
        const myGender = genderSelection || getGender();
        let tmpCurrentNavItem = { ...nestedNavigation };
        const rootNavigation = getRootNavigation(navigationPath, tmpCurrentNavItem);
        const navigationNamesForTracking = [];
        let selectedNavItem = '';
        let highlights = {};
        let shopBy = {};

        navigationPath.forEach((index) => {
            const navigationItemFromPath = tmpCurrentNavItem.children[index];

            if (navigationItemFromPath?.children && Object.keys(navigationItemFromPath.children).length > 0) {
                tmpCurrentNavItem = navigationItemFromPath;
                navigationNamesForTracking.push(getNavigationTrackingName(navigationItemFromPath));

                if (tmpCurrentNavItem.lvl === 1) {
                    highlights = highlights[index];
                    shopBy = shopBy[index];
                }
            } else {
                // remove uuid of navItem without children from navigationPath
                selectedNavItem = navigationPath.pop();
            }
        });

        return {
            currentNavItem: tmpCurrentNavItem,
            highlights,
            shopBy,
            gender: tmpCurrentNavItem.gender || myGender,
            navigationPath,
            selectedNavItem,
            rootNavigation
        };
    };

    return { navigationStateFromPath };
};
